import React from 'react';
import { Box, FormControl, styled } from '@mui/material';
import { HeaderLayout } from '../../HeaderLayout';
import { SvgIconWrapper } from '../../../shared/Typography/SvgIconWrapper';
import { useTranslation } from 'react-i18next';
import TextFieldStyled from '../../../shared/TextFieldStyled';
import { Link, useNavigate } from 'react-router-dom';
import { B2B_URL } from '../../../../utils/constans/constans';
import { LogoWrapperQuotation } from '../../../shared/logos/LogoWrapperQuotation';

const LogoWrapper = styled(Box)(() => ({
    flex: '0 0 calc(22% - 10px)',
    maxWidth: 'calc(22% - 10px)',
    img: {
        maxWidth: '250px',
    },
}));

const SearchBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    flex: '0 0 calc(40.666667% + 20px)',
    maxWidth: 'calc(40.666667% + 20px)',
}));

const ActionBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    flex: '0 0 calc(30.3333% - 10px)',
    maxWidth: 'calc(30.3333% - 10px)',
}));

const ActionBoxWrapper = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    a: {
        color: '#06142e',
    },
    'img, a': {
        cursor: 'pointer'
    },
}));

export const TopHeader: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goToProfile = () => {
        navigate('/profile');
    };

    return (
        <>
            <HeaderLayout>
                <LogoWrapperQuotation />
                <SearchBox>
                    <FormControl fullWidth>
                        <TextFieldStyled
                            label={t('HEADER.SEARCH').toString()}
                        />
                    </FormControl>
                </SearchBox>
                <ActionBox>
                    <ActionBoxWrapper>
                        <SvgIconWrapper>
                            <img
                                src="/assets/icons/profil.svg"
                                onClick={goToProfile}
                            />
                        </SvgIconWrapper>
                        <Link to={'/logout'}>
                            {t('HEADER.LOGOUT').toString()}
                        </Link>
                        <Box component="span" sx={{ padding: '0 5px' }}>
                            /
                        </Box>
                        <Link to={'/profile'}>
                            {t('HEADER.PROFILE').toString()}
                        </Link>
                    </ActionBoxWrapper>
                </ActionBox>
            </HeaderLayout>
        </>
    );
};
